// ── Cart: re-render drawer + count badge via section rendering ──────────────
// openDrawer defaults to true — pass false when the drawer is already open
window.renderCart = function(openDrawer) {
  if (openDrawer !== false) $('body').addClass('cart-open');

  // Re-render the cart drawer section
  $.get('/?section_id=cart-drawer', function(html) {
    var $parsed = $($.parseHTML(html, document, true));
    var $drawer = $('.cart-drawer');

    var $newTitle  = $parsed.find('.cart-drawer_title');
    var $newItems  = $parsed.find('.js-cart-items');
    var $newFooter = $parsed.find('.cart-drawer_footer');
    var $newEmpty  = $parsed.find('.cart-drawer_empty');

    if ($newTitle.length)  $('.cart-drawer_title').replaceWith($newTitle);

    // Swap items list
    if ($newItems.length) {
      if ($('.js-cart-items').length) {
        $('.js-cart-items').replaceWith($newItems);
      } else {
        $('.cart-drawer_empty').replaceWith($newItems);
      }
    } else if ($newEmpty.length) {
      // Cart is now empty
      if ($('.js-cart-items').length) {
        $('.js-cart-items').replaceWith($newEmpty);
      }
    }

    // Swap footer
    if ($newFooter.length) {
      if ($('.cart-drawer_footer').length) {
        $('.cart-drawer_footer').replaceWith($newFooter);
      } else {
        $drawer.append($newFooter);
      }
    } else {
      $('.cart-drawer_footer').remove();
    }
  });

  // Re-render the header count badge
  $.get('/?section_id=header', function(html) {
    var $parsed = $($.parseHTML(html, document, true));
    var $newBadge = $parsed.find('[data-cart-count]');
    if ($newBadge.length) {
      if ($('[data-cart-count]').length) {
        $('[data-cart-count]').replaceWith($newBadge);
      }
    }
  });
};

function cartClose() {
  $('body').removeClass('cart-open');
}

/* ── Quantity capping ────────────────────────────────────────────────────────
   The cart does not reject over-quantity adds on this store (a variant with 2
   in stock will happily take 99), and /cart/add.js is *cumulative* — it adds to
   the existing line rather than setting it. So 5 already in the cart plus a
   typed 6 becomes 11. The input's `max`, rendered by product-form-row.liquid as
   stock minus what the cart already holds, is the only thing enforcing stock;
   everything below keeps the value inside it. */

function qtyCap($input) {
  var max = parseInt($input.attr('max'), 10);
  return isNaN(max) ? null : max;
}

function qtyNote($input) {
  return $input.closest('.product_form-row').nextAll('[data-qty-note]').first();
}

/* Reflect the current value against the cap: disable the buttons that would
   step out of range and surface a "only N left" note at the ceiling. */
window.syncQtyState = function (input) {
  var $input = $(input);
  if (!$input.length) return;

  var cap   = qtyCap($input);
  var val   = parseInt($input.val(), 10) || 1;
  var $wrap = $input.closest('.product_qty-wrap');

  var atCap = cap !== null && val >= cap;
  $wrap.find('.product_qty-btn[data-action="increment"]').prop('disabled', atCap);
  $wrap.find('.product_qty-btn[data-action="decrement"]').prop('disabled', val <= 1);

  var $note = qtyNote($input);
  if (!$note.length) return;
  if (atCap && cap > 0) {
    $note.text('Only ' + cap + ' left in stock.').prop('hidden', false);
  } else {
    $note.text('').prop('hidden', true);
  }
};

function setQty($input, next) {
  var cap = qtyCap($input);
  next = Math.max(1, next);
  if (cap !== null) next = Math.min(next, Math.max(1, cap));
  $input.val(next);
  window.syncQtyState($input[0]);
  return next;
}

/* Qty stepper — shared by main-product and featured-product */
$(document).on('click', '.product_qty-btn', function () {
  var $btn = $(this);
  var $wrap = $btn.closest('.product_qty-wrap');
  var $input = $wrap.find('input[type="number"][name="quantity"]');
  if (!$input.length) return;
  var val = parseInt($input.val(), 10) || 1;
  setQty($input, $btn.data('action') === 'decrement' ? val - 1 : val + 1);
});

/* A typed value bypasses the stepper entirely, so clamp it too */
$(document).on('change', 'input[type="number"][name="quantity"]', function () {
  setQty($(this), parseInt(this.value, 10) || 1);
});

$(function () {
  $('input[type="number"][name="quantity"]').each(function () {
    window.syncQtyState(this);
  });
});

/* Add to cart — click on .product_atc, serialize form, POST /cart/add.js */
$(document).on('click', '.product_atc', function (e) {
  e.preventDefault();
  var $btn = $(this);
  if ($btn.prop('disabled')) return;
  var $form = $btn.closest('form');
  if (!$form.length) return;

  var $input = $form.find('input[type="number"][name="quantity"]');
  var cap    = $input.length ? qtyCap($input) : null;
  var $note  = $input.length ? qtyNote($input) : $form.find('[data-qty-note]').first();

  if (cap !== null && cap <= 0) {
    if ($note.length) $note.text('All available stock is already in your cart.').prop('hidden', false);
    return;
  }

  /* Re-clamp before serializing — the form is the last gate before the cart */
  var qty = $input.length ? setQty($input, parseInt($input.val(), 10) || 1) : 1;
  var formData = $form.serialize();

  /* .text() on the button would eat the label span and trailing icon */
  var $label = $btn.find('span').first();
  var $target = $label.length ? $label : $btn;
  var originalText = $target.text();
  var maxedOut = false;

  $btn.prop('disabled', true);
  $target.text('Adding…');

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: formData,
    success: function () {
      /* The line just grew, so the remaining headroom shrinks by what we added.
         Without this the next click could add over stock again before reload. */
      if ($input.length && cap !== null) {
        var remaining = Math.max(0, cap - qty);
        $input.attr('max', remaining);
        $input.attr('data-in-cart', (parseInt($input.attr('data-in-cart'), 10) || 0) + qty);
        setQty($input, 1);
        if (remaining <= 0) {
          maxedOut = true;
          $target.text('All stock in cart');
        }
      }
      if ($note.length && !maxedOut) $note.text('').prop('hidden', true);
      if (typeof window.renderCart === 'function') window.renderCart();
    },
    error: function (xhr) {
      /* Previously this fell back to $form[0].submit(), which silently re-posted
         the same add as a full page load — hiding the reason and risking a
         second add. Show what the cart actually said instead. */
      var msg = 'Sorry, we could not add that to your cart.';
      try {
        var data = JSON.parse(xhr.responseText);
        if (data && data.description) msg = data.description;
      } catch (err) { /* non-JSON response — keep the generic message */ }
      if ($note.length) $note.text(msg).prop('hidden', false);
    },
    complete: function () {
      if (maxedOut) return;
      $btn.prop('disabled', false);
      $target.text(originalText);
    }
  });
});

$(document).on('click', '#cart-icon-bubble', function(e) {
  e.preventDefault();
  $('body').addClass('cart-open');
});
$(document).on('click', '.js-cart-close, .js-cart-overlay, .cart-overlay', function() {
  cartClose();
});
$(document).on('click', '.js-qty-change', function() {
  var line   = $(this).data('line');
  var change = parseInt($(this).data('change'), 10);
  var max    = parseInt($(this).data('max'), 10);
  var $num   = $(this).siblings('.cart-drawer_qty-num');
  var current = parseInt($num.text(), 10) || 1;
  var newQty  = Math.max(0, current + change);
  /* Cap at the line's stock — /cart/change.js will not do it for us */
  if (!isNaN(max)) newQty = Math.min(newQty, max);
  if (newQty === current) return;
  $.post('/cart/change.js', { line: line, quantity: newQty }, function() {
    window.renderCart(false);
  });
});
$(document).on('keydown', function(e) {
  if (e.key === 'Escape') cartClose();
});


$(function () {

  // ── AJAX filter engine — Shopify Search & Discovery filters ──────
  // Filter inputs are rendered by the section straight from collection.filters,
  // so their names/values (filter.v.availability, filter.p.m.custom.x,
  // filter.v.price.gte …) are already the params Shopify expects. We only
  // serialize them, keep sort_by alongside, and swap the grid + sidebar.
  var sectionId = $('#product-grid').data('id');

  // Collection base path, e.g. /collections/olive-oil (drops any /tag segment)
  function basePath() {
    var path = window.location.pathname;
    var match = path.match(/^\/collections\/[^/]+/);
    return match ? match[0] : path;
  }

  // Active tag: from the path (/collections/olive-oil/evoo) or a legacy ?tag=
  function currentTag() {
    var match = window.location.pathname.match(/^\/collections\/[^/]+\/([^/]+)/);
    if (match) return decodeURIComponent(match[1]);
    return new URLSearchParams(window.location.search).get('tag') || '';
  }

  function pushParam(params, seen, name, value) {
    if (!name || value === '' || value == null) return;
    var key = name + '=' + value;
    if (seen[key]) return;
    seen[key] = true;
    params.push(encodeURIComponent(name) + '=' + encodeURIComponent(value));
  }

  // Build query string from all active filter inputs + sort
  function buildParams() {
    var params = [];
    var seen = {};

    $('#CollectionFilters, #CollectionFilterDrawer')
      .find('.collection-grid_filter-checkbox:checked, .collection-grid_filter-radio:checked')
      .each(function () {
        if (this.disabled) return;
        pushParam(params, seen, this.name, this.value);
      });

    // Price inputs — read from the visible container only (drawer when open, else sidebar)
    var $drawer = $('#CollectionFilterDrawer');
    var $priceScope = ($drawer.length && $drawer.hasClass('is-open')) ? $drawer : $('#CollectionFilters');
    $priceScope.find('.collection-grid_price-input').each(function () {
      pushParam(params, seen, this.name, this.value);
    });

    // Sort — rides along with the filters so both stay applied together
    var sortVal = $('#SortBy').val();
    if (sortVal) pushParam(params, seen, 'sort_by', sortVal);

    return params.join('&');
  }

  // Replace the rendered filter groups with the server's (updated counts,
  // active states, availability) while keeping accordions open/closed as-is.
  function syncFilters($parsed) {
    ['#CollectionFilters', '#CollectionFilterDrawer'].forEach(function (sel) {
      var $cur = $(sel);
      var $new = $parsed.find(sel);
      if (!$cur.length || !$new.length) return;

      var expanded = [];
      $cur.find('.collection-grid_filter-group').each(function () {
        expanded.push($(this).find('.collection-grid_filter-body').is(':visible'));
      });

      var $curGroups = $cur.find('.collection-grid_filter-group');
      var $newGroups = $new.find('.collection-grid_filter-group');

      if ($curGroups.length === $newGroups.length) {
        $curGroups.each(function (i) {
          $(this).html($newGroups.eq(i).html());
        });
      } else {
        // Filter set changed shape — rebuild the groups in place
        $curGroups.remove();
        var $anchor = $cur.find('.collection-grid_filter-heading');
        var $clone = $newGroups.clone();
        if ($anchor.length) $anchor.after($clone);
        else $cur.prepend($clone);
      }

      $cur.find('.collection-grid_filter-group').each(function (i) {
        var isOpen = expanded[i] === true;
        var $body = $(this).find('.collection-grid_filter-body');
        $(this).find('[data-filter-group-toggle]').attr('aria-expanded', isOpen ? 'true' : 'false');
        isOpen ? $body.show() : $body.hide();
      });
    });
  }

  // Fetch the section and swap the product grid + filters.
  // Tag filtering uses Shopify's path form (/collections/x/tag) so it composes
  // with the app's filters, sort and pagination server-side.
  function renderPage(params, tagOverride) {
    var $grid = $('#ProductGridContainer');
    if (!$grid.length) return;

    var base = basePath();
    var tag = tagOverride !== undefined ? tagOverride : currentTag();
    var fetchPath = tag ? base + '/' + encodeURIComponent(tag) : base;
    var newUrl = fetchPath + (params ? '?' + params : '');

    $grid.css('opacity', 0.4);

    var url = fetchPath + '?section_id=' + sectionId + (params ? '&' + params : '');

    $.get(url, function (html) {
      var $parsed = $($.parseHTML(html, document, true));

      var newGrid = $parsed.find('#ProductGridContainer').html();
      if (newGrid) $grid.html(newGrid);

      syncFilters($parsed);

      // Update browser URL without reload — a refresh/share renders the same page
      history.pushState({ params: params, tag: tag }, '', newUrl);

      // Scroll to optional shared anchor (place once per page).
      var headerOffset = 80;
      var anchor = document.getElementById('AjaxScrollAnchor') || document.getElementById('ProductGridContainer');
      if (anchor) {
        var top = anchor.getBoundingClientRect().top + window.scrollY - headerOffset;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      }

      if ($('.filter-btn.light-btn').length) updateLightFilters();

      $grid.css('opacity', 1);
    }).fail(function () {
      $grid.css('opacity', 1);
      window.location.href = newUrl;
    });
  }

  // ── Filter accordions (first group has .is-open, keep visible) ────
  $('.collection-grid_filter-body:not(.is-open)').hide();

  $(document).on('click', '[data-filter-group-toggle]', function () {
    var $toggle = $(this);
    var $body   = $toggle.closest('.collection-grid_filter-group').find('.collection-grid_filter-body');
    if (!$body.length) return;

    if ($body.is(':visible')) {
      $body.slideUp(220);
      $toggle.attr('aria-expanded', 'false');
    } else {
      $body.slideDown(260);
      $toggle.attr('aria-expanded', 'true');
    }
  });

  // ── Filter changes: AJAX (no page reload) ─────────────────────────
  $(document).on('change', '.collection-grid_filter-checkbox, .collection-grid_filter-radio', function () {
    renderPage(buildParams());
  });

  $(document).on('keydown', '#CollectionFilters .collection-grid_price-input, #CollectionFilterDrawer .collection-grid_price-input', function (e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      renderPage(buildParams());
    }
  });
  $(document).on('click', '[data-price-apply]', function () {
    renderPage(buildParams());
  });

  $(document).on('click', '[data-filter-apply]', function (e) {
    e.preventDefault();
    renderPage(buildParams());
    $('#CollectionFilterDrawer, #CollectionFilters').removeClass('is-open');
    $('#FilterOverlay').removeClass('is-open');
    $('body').css('overflow', '');
    $('[data-filter-toggle]').attr('aria-expanded', 'false');
  });

  // Clear all — drop every filter but stay on the current tag
  $(document).on('click', '[data-filter-clear]', function (e) {
    e.preventDefault();
    renderPage('');
    $('#CollectionFilterDrawer, #CollectionFilters').removeClass('is-open');
    $('#FilterOverlay').removeClass('is-open');
    $('body').css('overflow', '');
    $('[data-filter-toggle]').attr('aria-expanded', 'false');
  });

  // ── Sort by — Select2 ─────────────────────────────────────────────
  var $sortBy = $('#SortBy');
  if ($sortBy.length && !$sortBy.hasClass('select2-hidden-accessible') && $.fn.select2) {
    $sortBy.select2({
      minimumResultsForSearch: -1,
      placeholder: 'Sort By',
      width: '196px'
    });
  }
  $sortBy.off('change.collectionSort').on('change.collectionSort', function () {
    if (sectionId) renderPage(buildParams());
  });

  // ── Collection pagination: AJAX (stay on page + anchor scroll)
  // paginate URLs already carry the active filter + sort params.
  $(document).on('click', '#ProductGridContainer .pagination a[href], #ProductGridContainer a.pagination__item[href]', function (e) {
    if (!sectionId) return;
    var href = this.getAttribute('href');
    if (!href) return;

    e.preventDefault();

    var url = new URL(href, window.location.origin);
    var tagMatch = url.pathname.match(/^\/collections\/[^/]+\/([^/]+)/);
    var tag = tagMatch ? decodeURIComponent(tagMatch[1]) : (url.searchParams.get('tag') || '');
    url.searchParams.delete('tag');
    renderPage(url.searchParams.toString(), tag);
  });

  // Handle browser back/forward
  $(window).on('popstate', function () {
    renderPage(window.location.search.slice(1), currentTag());
    if ($('.filter-btn.light-btn').length) updateLightFilters();
  });

  // Product tag filters: sync active state from the current URL
  function updateLightFilters() {
    var tag = currentTag();
    $('.filter-btn.light-btn[data-tag]').each(function () {
      var $el = $(this);
      var btnTag = $el.attr('data-tag') || '';
      var isActive = (btnTag === tag);
      $el.toggleClass('filter-btn--active', isActive);
      $el.attr('aria-pressed', isActive ? 'true' : 'false');
      if (isActive) $el.attr('aria-current', 'true'); else $el.removeAttr('aria-current');
    });
  }

  $(document).on('click', '.filter-btn.light-btn[data-tag]', function (e) {
    if (!sectionId) return;
    e.preventDefault();
    var tag = this.getAttribute('data-tag') || '';
    renderPage(buildParams(), tag);
  });

  if ($('.filter-btn.light-btn').length) updateLightFilters();
});
